import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import LoadingBackdrop from "../components/loading-backdrop";
import {
  adminReferralsApi,
  AdminReferralRow,
} from "../services/api/admin-referrals";

function formatCents(cents: number) {
  return `$${(cents / 100).toFixed(2)}`;
}

export default function AdminReferralsPage() {
  const [busy, setBusy] = useState(false);
  const [rows, setRows] = useState<AdminReferralRow[]>([]);

  const load = async () => {
    setBusy(true);
    try {
      const res = await adminReferralsApi.get();
      setRows(res.Rows || []);
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h5">Admin: Referrals</Typography>

        <Button component={RouterLink} to="/admin" variant="outlined">
          Admin Home
        </Button>
      </Box>
      <Card>
        <CardContent>
          <Typography sx={{ mb: 1 }}>
            Referral enrollments and totals (manual payout workflow).
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Referrer</TableCell>
                <TableCell>Code</TableCell>
                <TableCell align="right">Conversions</TableCell>
                <TableCell align="right">Earned</TableCell>
                <TableCell align="right">Paid</TableCell>
                <TableCell align="right">Owed</TableCell>
                <TableCell>Enrolled</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.ReferrerUserID}>
                  <TableCell>{r.ReferrerEmail}</TableCell>
                  <TableCell>{r.Code}</TableCell>
                  <TableCell align="right">{r.ConversionsCount}</TableCell>
                  <TableCell align="right">
                    {formatCents(r.TotalEarnedCents)}
                  </TableCell>
                  <TableCell align="right">
                    {formatCents(r.TotalPaidCents)}
                  </TableCell>
                  <TableCell align="right">
                    {formatCents(r.TotalOwedCents)}
                  </TableCell>
                  <TableCell>{r.CreatedAt}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <LoadingBackdrop open={busy} />
    </Box>
  );
}
